import swal from "sweetalert";
import axiosInstance from "../api";
import { setgetsingleTicket, setGetTicketsList } from "../reusable/reusableSlice";

export const getAllTicketsListData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`/ticket_category/ticket_category_list`,data);
      if (response?.data) {
        dispatch(setGetTicketsList(response?.data?.response))
        return response
      } else {
        dispatch(setGetTicketsList([]))
      }
    } catch (err) {
      dispatch(setGetTicketsList([]))
    }
  };

  export const deleteOneTicket = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.delete(`/ticket_category/delete/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        dispatch(getAllTicketsListData({page:1}))
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } 
  };

  export const createNewTicket = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("/ticket_category/add", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/ticketslist")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const getSingleTicketById = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/ticket_category/get_by_id/${id}`);
      if (response?.data) {
        dispatch(setgetsingleTicket(response?.data?.response))
      } else {
        dispatch(setgetsingleTicket([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setgetsingleTicket([]))
    }
  };

  export const updateOneTicket = (data, setLoading, navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("/ticket_category/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        dispatch(getSingleTicketById(data.id))
      }
      else {
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };